<template>
  <div class="sn-f-b-s cloud-film">
    <sn-navigator id="BGCX" :initial="initial"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s cloud-film-region">
      <sn-breadcrumb :breadcrumb="[{ title: $sn.utils.getFunctionTitle('0', initial) }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 cloud-film-blank">
        <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
          <div class="sn-f-s-c region" v-if="$sn.validate.array(patientArray) && !$sn.validate.empty(patientArray)">
            <div class="sn-f-s-c patient-title">
              <div>{{ cloudFilmType === '2' ? '选择住院已认证用户：' : '选择就诊人：' }}</div>
            </div>
            <el-select :value="selectedPatient.patientId" @change="changePatient">
              <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientArray"></el-option>
            </el-select>
          </div>

          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>{{ cloudFilmType === '2' ? '住院人姓名' : '就诊人姓名' }}：</div>
            </div>
            <div >
              <el-input v-model="patientName" placeholder="请输入患者真实姓名"></el-input>
            </div>
          </div>
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>{{ cloudFilmType === '2' ? '住院号' : '就诊卡' }}：</div>
            </div>
            <div >
              <el-input v-model="cardNo" :placeholder="cloudFilmType === '2' ? '请输入患者住院号' : '请输入患者就诊卡号'"></el-input>
            </div>
          </div>
          <div class="sn-f-s-c region"><el-button type="primary" @click="searchBtn">查询</el-button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import * as Initial from '@/common/utils/initial';
import * as Constants from '@/common/utils/constants';
import * as ServiceConfig from '@/common/utils/service-config';

export default {
  components: {},
  data() {
    return {
      perpetual: Constants,
      cloudFilmType: '1', // 1门诊  2住院
      patientArray: [], // 就诊人列表
      selectedPatient: {}, // 当前就诊人
      patientName: '', // 姓名
      cardNo: '' // 卡号
    };
  },

  computed: {
    // 当前功能 ID
    initial() {
      return [this.perpetual.FUNCTION_ID_MZYJP, this.perpetual.FUNCTION_ID_ZYYJP][this.cloudFilmType - 1];
    }
  },
  watch: {
    // 切换就诊人
    selectedPatient: async function(patient) {
      if (patient.patientId) {
        this.patientName = patient.patientName;
        if (this.cloudFilmType === '1') this.cardNo = patient.outCardNo || '';
        else this.cardNo = patient.inCardNo || '';
      }
    },
    $route(old) {
      if (old.path === '/query/cloud-film') this.handlePatientInfo();
    },
    // 名字
    patientName: {
      handler: function(val) {
        if (val) {
          if (this.cloudFilmType === '1') {
            if (val !== this.selectedPatient.patientName || this.cardNo !== this.selectedPatient.outCardNo) this.selectedPatient = {};
          }
          else {
            if (val !== this.selectedPatient.patientName || this.cardNo !== this.selectedPatient.inCardNo) this.selectedPatient = {};
          }
        }
      },
      immediate: true
    },
    // 卡号
    cardNo: {
      handler: function(val) {
        if (val) {
          if (this.cloudFilmType === '1') {
            if (val !== this.selectedPatient.outCardNo || this.patientName !== this.selectedPatient.patientName) this.selectedPatient = {};
          }
          else {
            if (val !== this.selectedPatient.inCardNo || this.patientName !== this.selectedPatient.patientName) this.selectedPatient = {};
          }
        }
      },
      immediate: true
    }
  },
  created() {
    this.handlePatientInfo();
  },

  methods: {
    // 处理就诊人信息
    async handlePatientInfo() {
      this.cloudFilmType = this.$route.query.type || '1';
      document.title = this.$sn.utils.getFunctionTitle('0', this.initial);
      this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.initial);
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList') || [];
      if (this.cloudFilmType === '2') this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList').filter(item => item.inCardNo);
    },
    // 切换就诊人
    changePatient(id) {
      if (id) {
        this.selectedPatient = this.patientArray.find(item => item.patientId === id);
        this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
      }
    },
    // 获取云胶片地址
    searchBtn() {
      if (this.$sn.validate.empty(this.patientName)) {
        this.getShowToast(this.$sn.format.caption(Messages.C031, ['姓名']));
        return false;
      }
      if (this.$sn.validate.empty(this.cardNo)) {
        this.getShowToast(this.$sn.format.caption(Messages.C031, [this.cloudFilmType === '2' ? '住院号' : '门诊号']));
        return false;
      }
      const xml = {
        CardNo: this.cardNo,
        PatName: this.patientName,
        CardType: this.cloudFilmType
      };
      const params = {
        url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), 'b7a5c8f3-0b40-4d7c-9cea-e6edd955f4b1']),
        method: 'POST',
        header: true,
        data: this.$sn.utils.variableEncryption(this.$sn.format.xml(xml))
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data) {
          if (result.data.ResultCode === '0') {
            if (result.data.Data) window.open(result.data.Data);
          }
          else this.getShowToast(result.data.ResultMsg);
        }
        else this.getShowToast(result?.msg || Messages.C001);
      });
    },
    // 单纯的弹窗显示信息
    getShowToast(caption) {
      this.$sn.assembly.toast({
        caption: caption
      });
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.cloud-film {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  &-region {
    overflow: hidden;
    height: 100%;

    .cloud-film-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding-right: 20px;
      display: flex;
      flex-direction: column;

      .el-button {
        padding: 10px 20px;
        background-color: $main1;
        border-color: $main1;
      }

      ::v-deep .el-select {
        width: 200px;
      }
    }
  }
}
</style>
